export const CheckoutActions = {
  recovery: 'recovery',
}
